import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
import { Globals } from "../Globals";
import { useTranslation } from "react-i18next";

const SettingDropdown = ({ tenant }) => {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isExpired, setisExpired] = useState(false);

  useEffect(() => {
    const expiredOrNot = async (tenantId) => {
      const resIsExpired = await axios.get(
        `${Globals.API_URL}/api/data-sources/is-tenant-expired/${tenantId}`
      );
      setisExpired(resIsExpired.data === "expired");
    };
    expiredOrNot(tenant.id);
  }, [tenant.id]);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <>
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggle}
      >
        <div style={{position: 'relative'}}>
          <DropdownToggle
            className="btn header-item noti-icon waves-effect"
            tag="button"
          >
            <i className="mdi mdi-settings-outline"></i>
          </DropdownToggle>
          {isExpired && <i className="mdi mdi-alert-circle" />}
        </div>
        <DropdownMenu right>
          <DropdownItem tag={Link} to="/user-settings">
            {t("Settings")}
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem tag={Link} to="/data-sources">
            <i className="mdi mdi-database-outline me-2"></i>
            {t("Data kilder")}
          </DropdownItem>
          {['sponsor', 'association'].includes(tenant?.template) && (
            <DropdownItem tag={Link} to="/sponsor-contracts">
              <i className="mdi mdi-handshake-outline me-2"></i>
              {t("Platforms")}
            </DropdownItem>
          )}
          {tenant?.features?.['tracked-accounts'] && (
            <DropdownItem tag={Link} to="/tracked-accounts">
              {t("tracked_accounts_menu")}
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

const mapStateToProps = (state) => ({
  tenants: state.auth.tenants,
  tenant: state.auth.tenant,
});

export default connect(mapStateToProps)(SettingDropdown);
